import React from 'react'
import { connect } from 'react-redux'
import { Card } from 'react-bootstrap'

import {
  handleAdverseEventFieldChange,
  submitCefiderocolAdverseEvent,
  deleteAdverseEvent,
 } from '../reducers/antibioticsUseFormReducer'
 import {
   handleChartFieldChange,
 } from '../reducers/chartFormReducer'

import FormInput from '../../../components/FormInput'
import SelectWithOptionalTextField from '../../../components/SelectWithOptionalTextField'
import ConfirmationPopover from '../../../components/ConfirmationPopover'

const CefiderocolAdverseEvent = (props) => {

  const {
    name,
    date_of_onset,
    event_duration_days,
    event_severity,
    event_seriousness,
    event_outcome,
    event_reported_to_health_authority,
    chartForReview,
    action_taken,
    chartDateErrorMessage
  } = props

  const handleChange = (e) => {
    const { name, value } = e.target
    return props.handleAdverseEventFieldChange(props.id, name, value)
  }

  const handleDateChange = (name, date) => {
    props.handleAdverseEventFieldChange(props.id, name, date)
    props.handleChartFieldChange('chartDateErrorMessage', '')
    if ((date instanceof Date && !isNaN(date)) || date === null) {
      const adverseEvent = {...props, [name]: date, 'chartDateErrorMessage': name}
      return props.submitCefiderocolAdverseEvent(adverseEvent)
    }
  }

  const handleBlur = () => {
    props.submitCefiderocolAdverseEvent(props)
  }

  const handleRemove = () => {
    return props.deleteAdverseEvent(props)
  }

  const handleEventSeriousnessChange = (e) => {
    handleChange(e)
    if (e.target.name === 'event_seriousness') {
      props.handleAdverseEventFieldChange(props.id, 'event_seriousness_reason', '')
    }
  }

  const getHelperText = (key) => {
    if (!props[`${key}`]) {
      if (chartDateErrorMessage && chartDateErrorMessage !== '' && chartDateErrorMessage.includes('[')) {
        let name = chartDateErrorMessage.split('[')[1].split(']')[0]
        if (key === name || name.includes(`${key}`)) {
          return chartDateErrorMessage.split('[')[0]
        } else {
          return 'Date is Invalid'
        }
      } else {
        return 'Date is Invalid'
      }
    } else {
      return 'Date is Valid'
    }
  }

  const popoverContent = (
    <div>
      <p>Remove adverse drug reaction <strong>{name}</strong>?</p>
      <br/>
      <p>This action will <strong>delete the adverse from the database</strong>.</p>
    </div>
  )

  const eventSeverityOptions = [
    {value: 'Severity not reported'},
    {value: 'Mild (A finding or symptom is minor and does not interfere with usual daily activities.)'},
    {value: 'Moderate (The event is discomfort and causes interference with usual daily activity or affects clinical status.)'},
    {value: "Severe (The event causes interruption of the patient's usual daily activities or has a clinically significant effect.)"},
  ]

  const eventSeriousnessOptions = [
    {value: 'Not reported'},
    {value: 'No, it is not serious'},
    {
      value: 'Yes, it is a serious adverse drug reaction',
      selectFields: [
        {
          fieldName: 'event_seriousness_reason',
          displayName: 'The reason for being a serious Adverse Drug Reaction',
          options: [
            {value: 'Death'},
            {value: 'Life-threatening condition'},
            {value: 'Hospitalization or prolongation of existing hospitalization for treatment'},
            {value: 'Persistent or significant disability/incapacity'},
            {value: 'Other medically important condition'},
          ]
        }
      ]
    },
  ]

  const eventReportedToHealthAuthorityOptions = [
    {value: 'No'},
    {value: 'Yes'},
    {value: 'Unknown'},
  ]

  const actionTakenOptions = [
    {value: 'Drug Withdrawn'},
    {value: 'Dose Change'},
    {value: 'No Change'},
  ]

  return (
    <Card>
      <Card.Body>

        <FormInput
           label="Name"
           type='text'
           name='name'
           value={name}
           onChange={handleChange}
           onBlur={handleBlur}
           placeholder='Enter the name of the Adverse Drug Reaction'
           disabled={chartForReview}
           required={true}
         />

       <FormInput
          label="Date of onset"
          type='date'
          value={date_of_onset}
          onChange={(date) => handleDateChange('date_of_onset', date)}
          onBlur={handleBlur}
          disabled={chartForReview}
          required={true}
          errorText={getHelperText('date_of_onset')}
        />

        <FormInput
           label="Duration of the event (days)"
           type='number'
           name='event_duration_days'
           value={event_duration_days}
           onChange={handleChange}
           onBlur={handleBlur}
           placeholder='Enter the duration of the event in days'
           disabled={chartForReview}
           required={true}
         />

          <SelectWithOptionalTextField
            label="What was the severity of the event reported by the treating physician? (see the definition in info button)"
            options={eventSeverityOptions}
            handleChange={handleChange}
            selectFieldName={'event_severity'}
            selected={event_severity}
            onBlur={handleBlur}
            disabled={chartForReview}
            infoText={
              <>
                <p>
                  Mild: A finding or symptom is minor and does not interfere with usual daily activities.
                </p>

                <p>
                  Moderate: The event is discomfort and causes interference with usual daily activity or affects clinical status.
                </p>

                <p>
                  Severe: The event causes interruption of the patient's usual daily activities or has a clinically significant effect.
                </p>
              </>
            }
            placeholder="Please make a selection"
            required={true}
            {...props}
          />

          <SelectWithOptionalTextField
            label="What was the seriousness reported by the treating physician?"
            options={eventSeriousnessOptions}
            handleChange={handleEventSeriousnessChange}
            selectFieldName={'event_seriousness'}
            selected={event_seriousness}
            onBlur={handleBlur}
            disabled={chartForReview}
            placeholder="Please make a selection"
            required={true}
            {...props}
          />

          <FormInput
            label="Outcome of the event"
            type='text'
            name='event_outcome'
            value={event_outcome}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder='Enter the outcome of the event'
            disabled={chartForReview}
            required={true}
          />

          <SelectWithOptionalTextField
            label="Action taken about Cefiderocol"
            options={actionTakenOptions}
            handleChange={handleChange}
            selectFieldName={'action_taken'}
            selected={action_taken}
            onBlur={handleBlur}
            disabled={chartForReview}
            placeholder="Please make a selection"
            required={true}
            {...props}
          />

          <SelectWithOptionalTextField
            label="Has this event been reported to the health authority or to Shionogi?"
            options={eventReportedToHealthAuthorityOptions}
            handleChange={handleChange}
            selectFieldName={'event_reported_to_health_authority'}
            selected={event_reported_to_health_authority}
            onBlur={handleBlur}
            disabled={chartForReview}
            placeholder="Please make a selection"
            required={true}
            {...props}
          />

          {chartForReview ?
            null
            :
            <>
              <br/>
              <ConfirmationPopover
                triggerText='Remove the Currently Selected Adverse Drug Reaction'
                title='Delete Adverse Drug Reaction?'
                placement='top'
                popoverContent={popoverContent}
                onConfirm={handleRemove}
              />
            </>
          }

      </Card.Body>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return {
    antibiotics_use: state.antibioticsUseFormReducer.antibioticsUseInfoUrl,
    chartDateErrorMessage: state.chartFormReducer.chartDateErrorMessage,
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    handleAdverseEventFieldChange: (id, name, value) => {
      return dispatch(handleAdverseEventFieldChange(id, name, value))
    },
    submitCefiderocolAdverseEvent: (props) => {
      return dispatch(submitCefiderocolAdverseEvent(props))
    },
    deleteAdverseEvent: (props) => {
      return dispatch(deleteAdverseEvent(props))
    },
    handleChartFieldChange: (props) => {
      return dispatch(handleChartFieldChange(props))
    },
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(CefiderocolAdverseEvent)
